import styled from 'styled-components'

export const StyledMyPageMyVolumes = styled.div`
  padding: 0 15px;
`
